export default __webpack_public_path__ + "media/images/mailer/icon_person_add-75a4cb809cde7bcfb557908d0e6df248.png";